export const ContactType = {
  VISIT: 'VISIT',
  INTERVIEW: 'INTERVIEW',
  OTHERS: 'OTHERS',

  values: () => {
    return ['VISIT', 'INTERVIEW', 'OTHERS'];
  }
};
